// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__N1o0Z","reset":"styles_reset__y7XdC"};